__turbopack_context__.v({
  "draftTaxReturnReviewDialogMenu": "DraftTaxReturnReviewDialog-module__D1HH3G__draftTaxReturnReviewDialogMenu",
  "draftTaxReturnReviewDialogMenuOpen": "DraftTaxReturnReviewDialog-module__D1HH3G__draftTaxReturnReviewDialogMenuOpen",
  "draftTaxReturnReviewDialogMenu__toggle": "DraftTaxReturnReviewDialog-module__D1HH3G__draftTaxReturnReviewDialogMenu__toggle",
  "draftTaxReturnReviewDialog__headerRotate": "DraftTaxReturnReviewDialog-module__D1HH3G__draftTaxReturnReviewDialog__headerRotate",
  "pdfContainer": "DraftTaxReturnReviewDialog-module__D1HH3G__pdfContainer",
  "pdfContainerWithBookmarks": "DraftTaxReturnReviewDialog-module__D1HH3G__pdfContainerWithBookmarks",
});
